import React, { Component } from 'react';
import { connect } from 'react-redux';
import { orderBy } from 'lodash';
import { TableRow, TableCell, TableHead, TableFooter } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Point from '@material-ui/icons/ArrowDropDown';
import {
  navigateTo,
  saveHistory,
  setError,
  addUserToClinic,
  getUsers,
  getAdmins,
  setUsersClinic,
  getUsersByClinicId,
  removeUser,
  setSelectedUser,
  getClinicData,
} from '../../redux/actions';
import { patientListBaseStyles } from '../../theme/style';
import { Items, Storage } from '../../utils/StorageHelper';
import { Loading } from '../common';
import ClinicUserModal from '../clinic/ClinicUserModal';
import TableHeader from '../common/TableHeader';
import { getClinicByUserId, isAdmins, isLoggedInis, isUsers, statusTypes } from '../../utils/CFuncs';
import { adminTableFields, modalNames, roles, urls, userTableFields } from '../../utils/Objects';
import Table from '../common/EntityTable';
import EntityTable from '../common/EntityTable';
import RemoveUserModal from './RemoveUserModal';
import { closeModal, openModal } from '../../redux/actions/ModalAction';
import { createUsersTable } from '../../utils/TableHelper';

class UserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddUserModal: false,
      users: this.props.users || [],

    };

  }
  async componentDidMount() {
    const newUserList = await this.getAllDatas();
    this.setState({ users: newUserList });
    console.log('UserList didMount');
    const clinicId = Storage.get(Items.clinicId);
    if (clinicId) {
      if (!this.props.selectedClinic) this.props.getClinicData(clinicId);
      isUsers() && this.props.getUsersByClinicId(clinicId);
    } else {
      isAdmins() && this.props.getAdmins();
      isUsers() && this.props.getUsers();
    }
  }
  async componentDidUpdate(prevProps) {
    console.log('componentDidUpdate');
    console.log(this.props.users);
    if (JSON.stringify(this.props.users) !== JSON.stringify(prevProps.users)) {
      const newUserList = await this.getAllDatas();
      this.setState({ users: newUserList });
    }
  }

  openAddUserModal = () => {
    this.props.setError();
    this.setState({ showAddUserModal: true });
  };
  closeAddUserModal = () => {
    this.setState({ showAddUserModal: false });
  };

  getAllDatas = async () => {
    const users = this.props.users ?? [];
    const promises = users?.map(async (user) => {
      let clinicName = '';
      try {
        const myClinic = await getClinicByUserId(user.id);
        clinicName = myClinic?.name || '-';
      } catch (error) {
        console.log(error);
      }
      const statusName = statusTypes[user.status];

      const roleID = user.roleID === 0 ? 'Admin' : user.roleID == 1 ? 'User' : '-';
      const { lastName, firstName, email } = user;
      return {
        id: user.id,
        image: {
          picture: user.picture,
          id: user.id,
        },
        lastName,
        firstName,
        email,
        status: {
          statusName,
          pathname: urls.patientStatus,
          state: { user, prevPage: urls.users },
        },
        roleID,
        details: {
          pathname: urls.userDetails,
          state: { userId: user.id },
        },
        clinicName,
        remove: {
          pathname: urls.users,
          onClick: () => {
            this.props.setSelectedUser(user);
            this.props.openModal(modalNames.removeUser);
          },
          value: 'remove user',
        },
      };
    });
    const newList = await Promise.all(promises);
    console.log({ newList });
    return newList;
  };

  render() {
    let tableFields = isAdmins() ? adminTableFields : isUsers() ? userTableFields : [];

    console.log({ props: this.props });
    return (
      <div>
        {isUsers() && <h1> Users</h1>}
        {isAdmins() && <h1>Admins</h1>}
        {this.props.isLoading && <Loading />}

        {(Storage.get(Items.clinicId) || isLoggedInis(roles.HealthCareProvider)) && (
          <button style={{ ...styles.button, width: '10rem' }} onClick={this.openAddUserModal}>
            add user to clinic
          </button>
        )}
        <>
          <RemoveUserModal title="remove user" closeModal={this.props.closeModal} showModal={this.props.modal.modalName === modalNames.removeUser} />
          <ClinicUserModal
            closeModal={this.closeAddUserModal}
            showModal={this.state.showAddUserModal}
            handleClick={this.props.addUserToClinic}
            title="Add User To Clinic"
            clinicId={Storage.get(Items.clinicId)}
          />
        </>
        <EntityTable entities={this.state.users} tableFields={tableFields} />
      </div>
    );
  }
}

const styles = {
  button: {
    cursor: 'pointer',
    backgroundColor: '#4CAF50',
    border: 'none',
    color: 'white',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
};

const mapStateToProps = (state, ownProps) => {
  return {
    selectedClinic: state.clinic.selectedClinic,
    users: state.clinic.usersClinic,
    modal: state.modal,
    isLoading:state.message.isLoading
  };
};
const mapDispatchToProps = {
  saveHistory,
  navigateTo,
  setError,
  addUserToClinic,
  getUsers,
  getAdmins,
  setUsersClinic,
  getUsersByClinicId,
  closeModal,
  removeUser,
  setSelectedUser,
  openModal,
  getClinicData,
};
export default connect(mapStateToProps, mapDispatchToProps)(UserList);
